// extracted by mini-css-extract-plugin
export var container = "attribution-module--container--r04BA";
export var attributionContent = "attribution-module--attributionContent--jthhw";
export var attributionTitle = "attribution-module--attributionTitle--PxOTZ";
export var attributionSubtitle = "attribution-module--attributionSubtitle--++Mut";
export var attributionImageContainer = "attribution-module--attributionImageContainer--HYNb-";
export var attributionImage = "attribution-module--attributionImage--gsyfm";
export var attributionImageButton = "attribution-module--attributionImageButton--XCv3z";